import { PlaceE } from '../data/model'

export const deserializeE = (serializedS: string): PlaceE => {
  const serialized = serializedS.replace(/^e-/, '')
  const deserializedData = window.atob(serialized)
  const place = JSON.parse(deserializedData) as PlaceE

  return {
    latitude: Number(place.latitude),
    longitude: Number(place.longitude),
    providerId: place.providerId,
    version: place.version,
  }
}
